import React, { useEffect, useState } from 'react';
import { DraggableTableBody } from './DraggableTableBody';
import _ from 'lodash';
import './DraggableTable.css';
import { BlazeTableColDef, SelectAllType } from '../BlazeTable.types';
import BlazeTableHeader from '../BlazeTableHeader';
import FullPageLoader from '../../loaders/FullPageLoader';
import { useIsMount } from '../../../hooks/useIsMountHook';
import { SortConfiguration } from '../../../types/rest/paginationTypes';

interface DraggableBlazeTableProps {
  cols: BlazeTableColDef[];
  data: any[];
  onSelectionChange: (items: any[]) => void;
  onDragFinished: (items: any[]) => void;
  isLoading: boolean;
  expandableComponent?: (item: any) => any;
  showSelectAll?: boolean;
  selectedItems?: number[] | null;
  /** Read only sort by */
  sortBy?: SortConfiguration;
}
const DraggableTable = (props: DraggableBlazeTableProps) => {
  const [selectAll, setSelectAll] = useState<SelectAllType>(null);
  const isMount = useIsMount();

  //Reset select all if data is empty
  useEffect(() => {
    if (!isMount && _.size(props.data) === 0) {
      setSelectAll(null);
    }
  }, [props.data]);

  useEffect(() => {
    if (selectAll === 'ALL') {
      const allIds = props.data.map(item => item.id);
      props.onSelectionChange(allIds);
    } else {
      props.onSelectionChange([]);
    }
  }, [selectAll]);

  const selectAllHandler = () => {
    if (selectAll === 'ALL') {
      setSelectAll(null);
    } else {
      setSelectAll('ALL');
    }
  };
  return (
    <div className={'flex-table flex-table-xs'}>
      <div className="flex-table-item-top flex-table-item">
        <BlazeTableHeader
          blazeTableColDef={props.cols}
          selectAllType={selectAll}
          disabled={false}
          isSelectable={true}
          showSelectAll={_.isNil(props.showSelectAll) ? true : props.showSelectAll}
          selectColumnSize={_.isNil(props.expandableComponent) ? 90 : 120}
          onSelectAll={selectAllHandler}
          onDeselectAll={_.noop}
          selectedItemsCount={10}
          showRowExpander={false}
          expandColumnSize={10}
          isSortable={!_.isNil(props.sortBy)}
          sorting={props.sortBy}
        />
      </div>
      <div style={{ position: 'relative' }} className="mb-4">
        {props.isLoading && (
          <div className="blur-background" style={{ minHeight: 500 }}>
            <FullPageLoader loadingText={'Loading...'} />
          </div>
        )}
        <div className={props.isLoading ? 'blur' : ''}>
          <DraggableTableBody
            isSelectAll={selectAll !== null}
            onSelectionChanged={ids => {
              props.onSelectionChange(ids);
              if (ids.length === props.data.length && props.data.length !== 0) {
                setSelectAll('ALL');
              } else {
                setSelectAll(null);
              }
            }}
            items={props.data}
            columnDef={props.cols}
            onDragFinished={props.onDragFinished}
            expandableComponent={props.expandableComponent}
            selectedItems={props.selectedItems}
          />
        </div>
      </div>
    </div>
  );
};

export default DraggableTable;
